import {
    setIsFocused,
    setSubject,
    setLinkedEmailEntity,
    setExtractionId,
} from '../actions/quickAddActions';
import { initializeQuickAdd } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';
import { SUGGESTED_TASK_ENTITY_SUBTYPE } from '../store/schema/LinkedEntity';
import getLinkedEmailEntity from '../utils/getLinkedEmailEntity';

export const initializeQuickAddOrchestrator = orchestrator(initializeQuickAdd, actionMessage => {
    const { subject, linkedEmailEwsId, extractionId } = actionMessage;

    setSubject(subject);
    setIsFocused(true);
    setExtractionId(extractionId);

    if (linkedEmailEwsId) {
        const linkedEmailEntity = getLinkedEmailEntity(
            linkedEmailEwsId,
            SUGGESTED_TASK_ENTITY_SUBTYPE,
            subject
        );
        setLinkedEmailEntity(linkedEmailEntity);
    }
});
